export default __webpack_public_path__ + "static/media/login-bg.034e4ae4.png";